import { CircularProgress, Grid, Paper } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import backend from 'utils/backend'

const MAX_CONTACTS = 10

const getInitials = contact => {
  const firstInitial = contact.firstName?.trim()?.[0] || ''
  const lastInitial = contact.lastName?.trim()?.[0] || ''
  return `${firstInitial}${lastInitial}`.toUpperCase() || '?'
}

const UserList = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const { data, isLoading } = useQuery({
    queryKey: ['salesforceAccount'],
    queryFn: () => backend.get('/api/currentuser/account/').then(res => res.data)
  })

  const contacts = data?.contacts || []
  const totalContacts = contacts.length
  const availableSeats = Math.max(MAX_CONTACTS - totalContacts, 0)

  const you = contacts.find(contact => contact.isYou)
  const otherContacts = contacts
    .filter(contact => !contact.isYou)
    .sort((a, b) => a.name.localeCompare(b.name))
  const sortedContacts = you ? [you, ...otherContacts] : otherContacts

  return (
    <Grid className="user-list">
      <h3>{t.user.profile.usersTitle}</h3>
      <p>{t.user.profile.usersDescription}</p>
      <p className="small">{t.user.profile.usersInstructions}</p>
      {isLoading && <CircularProgress />}
      {!isLoading && (
        <>
          <Paper className="contacts-details">
            <div className="seats-count">
              <span className="total">{totalContacts}</span>
              <span className="slash">/</span>
              <span className="max">{MAX_CONTACTS}</span>
            </div>
            <div className="seats-meta">
              <p className="seats-label">{t.user.profile.seatsUsed}</p>
              <p className="seats-available">
                {t.user.profile.seatsAvailable.replace('{availableSeats}', availableSeats)}
              </p>
            </div>
          </Paper>
          <div className="contact-list">
            {sortedContacts.map(contact => (
              <div className="contact-item" key={contact.id || contact.email}>
                <div className="contact-badge">{getInitials(contact)}</div>
                <div className="contact-details">
                  <div className="contact-name-row">
                    <p className="contact-name">{contact.name}</p>
                    {contact.isYou && (
                      <span className="contact-you-badge">{t.user.profile.youBadge}</span>
                    )}
                  </div>
                  <p className="contact-email">{contact.email}</p>
                </div>
                <p className="contact-role">
                  {contact.isAccountManager ? t.user.profile.adminRole : t.user.profile.userRole}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
    </Grid>
  )
}

UserList.tabPath = 'users'
UserList.getTabName = t => t.user.profile.usersTitle

export default UserList
